export default "__VITE_ASSET__CRCHXcod__"